import SiafLiteApiRepository from "../../external/siafLiteApi";

class EmpresaService {
  constructor() {
    this.urlBase = "/painel-controle/empresas";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  get() {
    return new SiafLiteApiRepository(this.urlBaseEvent).get();
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }

  getFiliaisMatriz() {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/filiais-matriz`).get();
  }

  cadastrar(body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).post(body);
  }

  addImage(formData) {
    return new SiafLiteApiRepository(`${this.urlBaseEvent}/upload/imagem`).post(
      formData
    );
  }

  atualizar(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body);
  }

  deletar(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).delete(id);
  }

  atualizarInformacoesCedente(id, body) {
    return new SiafLiteApiRepository(this.urlBaseEvent).put(id, body, 'informacoes-cedente');
  }
}

export default EmpresaService;
